import { render, staticRenderFns } from "./CmgRewardsList.vue?vue&type=template&id=4d6307ba&scoped=true&lang=pug&"
import script from "./cmg-rewards-list.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-list.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsList.vue?vue&type=style&index=0&id=4d6307ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6307ba",
  null
  
)

export default component.exports